// osDetection.js
export const detectOS = () => {
  const userAgent = window.navigator.userAgent;
  const platform = window.navigator.platform;
  const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
  const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];

  if (macosPlatforms.indexOf(platform) !== -1) {
    return 'mac';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    return 'windows';
  } else if (/Linux/.test(platform)) {
    return 'linux';
  } else {
    return 'unknown';
  }
};
import { createGlobalStyle } from 'styled-components';

export const Reset = createGlobalStyle`
      /* Box sizing rules */
      *,
      *::before,
      *::after {
          box-sizing: border-box;
      }
  
      /* OS-specific font sizing */
      html.os-mac { 
          font-size: 62.5%; /* 10px base for Mac */
      }
  
      html.os-windows {
          font-size: 52%; /* ~75% of 62.5% to match 75% zoom on Windows */
      }
  
      html.os-linux, html.os-unknown {
          font-size: 62.5%; /* Default for other platforms */
      }

      @media screen and (min-width: 1440px) {
        html.os-windows {
          font-size: 62.5%; /* Maintain 62.5% for 1440px and above */
        }
      }
  
      /* Makes the font-size maths easier if OS detection fails */
      html:not(.os-mac):not(.os-windows):not(.os-linux):not(.os-unknown) { 
          font-size: 62.5%; /* 16px * 62.5% = 10px as fallback */
      }
  
      body {
          font-size: 1.6rem; /* 10px * 1.6rem = 16px */
          font-family: ${({ theme }) =>
            // eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error
            // @ts-ignore
            theme.font?.family ?? 'Lato'}, sans-serif;
      }
  
      /* Remove default margin */
      body,
      h1,
      h2,
      h3,
      h4,
      p,
      figure,
      blockquote,
      dl,
      dd {
          margin: 0;
      }
  
      /* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
      ul[role="list"],
      ol[role="list"] {
          list-style: none;
      }
  
      /* Set core root defaults */
      html:focus-within {
          scroll-behavior: smooth;
      }
  
      /* Set core body defaults */
      body {
          min-height: 100vh;
          text-rendering: optimizeSpeed;
          line-height: 1.5;
      }
  
      /* A elements that don't have a class get default styles */
      a:not([class]) {
          text-decoration-skip-ink: auto;
      }
  
      /* Make images easier to work with */
      img,
      picture {
          max-width: 100%;
          display: block;
      }
  
      svg {
          display: block;
      }
  
      /* Inherit fonts for inputs and buttons */
      input,
      button,
      textarea,
      select {
          font: inherit;
      }
  
      /* Remove all animations and transitions for people that prefer not to see them */
      @media (prefers-reduced-motion: reduce) {
          html:focus-within {
              scroll-behavior: auto;
          }
          *,
          *::before,
          *::after {
              animation-duration: 0.01ms !important;
              animation-iteration-count: 1 !important;
              transition-duration: 0.01ms !important;
              scroll-behavior: auto !important;
          }
      }
  `;
